export default __webpack_public_path__ + "static/media/platforma.2c1de0ff.png";